import TableOfContents from "./components/TableOfContents.svelte";
import {TocItem} from "./types/types";
import {mount} from "svelte";


document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll<HTMLElement>('[data-component="ac-toc"]').forEach(el => {
        const targetContainer = document.querySelector<HTMLElement>(el.dataset.target!);

        if (!targetContainer) {
            return
        }

        let items: TocItem[] = [];
        targetContainer.querySelectorAll<HTMLElement>('h1').forEach(tocItem => {
            let id = tocItem.id ? tocItem.id : 'introduction';
            tocItem.id = id;

            items.push({
                element: tocItem,
                id: id,
                title: 'Introduction',
                type: 'h1'
            })
        });
        targetContainer.querySelectorAll<HTMLElement>('h2').forEach(tocItem => {
            if (tocItem.id) {
                items.push({
                    element: tocItem,
                    title: tocItem.textContent,
                    id: tocItem.id,
                    type: tocItem.tagName.toLowerCase() as 'h2' | 'h3'
                })
            }
        })

        if (items.length <= 1) {
            return
        }

        mount(TableOfContents, {
            target: el,
            props: {
                items: items
            }
        })
    })

})

